import { Button } from "../../../../core/Button.js";
import { DescriptionList } from "../../../../core/DescriptionList.js";
import { Panel } from "../../../../core/Panel.js";
import type { AccountProfileContent } from "../../accountContent.js";

/**
 * Settings → Profile: the username other players see, with Change, and the facts of the account,
 * each a label beside its value.
 */
export function AccountProfile({ title, description, rows }: AccountProfileContent) {
  return (
    <Panel title={title} description={description}>
      <DescriptionList
        items={rows.map((row) => ({
          label: row.label,
          mono: row.mono,
          value: (
            <span className="inline-flex flex-wrap items-center gap-2 sm:justify-end">
              <span className={row.muted ? "text-text-tertiary" : undefined}>{row.value}</span>
              {row.actions?.map((action) => (
                <Button
                  key={action.label}
                  variant={action.emphasis === "primary" ? "primary" : "secondary"}
                  size="sm"
                  disabled={action.disabled}
                  loading={action.pending}
                  onClick={action.onClick}
                >
                  {action.label}
                </Button>
              ))}
            </span>
          ),
        }))}
      />
    </Panel>
  );
}
